import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filters a list of facet values, returning the set
 * that starts with the given searchTerm.
 */
@Pipe({
  name: 'facetRefineFilter',
  pure: true,
})
export class FacetRefineFilterPipe implements PipeTransform {
	  transform(items: any[], searchTerm: string): any[] {
	    if (!items || !searchTerm) {
	      return items;
	    }

	    let lowerSearchTerm = searchTerm.toLowerCase();

	    return items.filter(item => 
	      item.displayName.toLowerCase().startsWith(lowerSearchTerm)
	    );
	  }
}
